import { render, staticRenderFns } from "./AuthError.vue?vue&type=template&id=580b9151&"
import script from "./AuthError.vue?vue&type=script&lang=js&"
export * from "./AuthError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports